/**
 * Intercom Integration Module
 *
 * Usage:
 *
 * 1. Wrap your app with IntercomProvider:
 *    <IntercomProvider user={user} loadOnIdle={true}>
 *      <App />
 *    </IntercomProvider>
 *
 * 2. Add the facade button (optional, for custom launcher):
 *    <IntercomFacade />
 *
 * 3. Trigger chat from anywhere:
 *    - Use hook: const { show, showNewMessage } = useIntercom()
 *    - Or standalone: openIntercomChat("Hello!")
 *    - Or component: <IntercomButton>Chat</IntercomButton>
 */

export { IntercomProvider, useIntercom, openIntercomChat } from "./IntercomProvider"
export { IntercomFacade } from "./IntercomFacade"
export { default as IntercomButton } from "./IntercomButton"
